export * from "./src/searchTextFilterPlugin";